import { FC, Fragment } from 'react';
import IResult from 'models/Result';
import { v4 } from 'uuid';
import ResultItem from './ResultItem';
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';

const ResultsList:FC = () => {
  const result:any = useAppSelector(selectResult);
  const results:IResult[] = result?.results || [];
  const spotPrizeWinnerResult = result?.spotPrizeWinnerResult;

  if (!results.length) return null;
  return (
    <div
      className="relative overflow-hidden  rounded-3xl w-full mb-4 pt-6 sm:mb-8 shadow-primary-border"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}
    >
      {results.map((result, index) => (
        <ResultItem key={v4()} result={result} resultIndex={index} />
      ))}
      {spotPrizeWinnerResult ? (
        <Fragment>
          <div className="shadow-primary-border h-1 my-4" />
          <ResultItem key={v4()} result={spotPrizeWinnerResult} resultIndex={10} randomPrize />
        </Fragment>
      ) : null}
    </div>
  )
}

export default ResultsList;
